<template>
  <div class="wrapping-box-container">
    <div id="controls" class="controls"></div>
    <div class="loadingContainer">
      <Loader isLoading />
    </div>
  </div>
</template>

<script>
import Loader from '@/feature/minified-onboarding/components/Loader.vue';
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { FaceTec } from '@/services/facetec';
import logger from '../../../lib/logger';

export default {
  name: 'onboarding-selfie-faceTec-camera',
  components: { Loader },
  computed: {
    ...mapGetters('minifiedOnboarding', [
      'onboarding',
    ]),
  },
  async mounted() {
    if (!this.onboarding) {
      await this.$router.replace({
        name: 'onboarding-minified-instructions',
        query: this.$route.query,
      });
    }

    try {
      const { success } = await FaceTec.openSession();
      if (success) {
        FaceTec.onLivenessCheckPressed();
      }
    } catch (error) {
      logger.error(error);
      await this.$router.replace({
        name: 'onboarding-minified-selfie-error',
        query: this.$route.query,
      });
    }
  },
};
</script>
<style lang="scss">
.loadingContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
</style>
